import * as z from 'zod/v4';

export const activatedDrawIdSchema = z.number().brand<'ActivatedDrawId'>();
export type ActivatedDrawId = z.infer<typeof activatedDrawIdSchema>;
